module.exports = __webpack_public_path__ + "img/paraiba.633dbd92.jpg";